import { select, call, takeLatest } from 'redux-saga/effects';
import { ServiceTypeActions } from '../constants';
import { ServiceTypeApi } from 'src/services/end-points';
import { StoreState } from '../reducers';
import { PaginationService } from '../../services/api-handlers/pagination';
import {
    DeleteServiceTypeAction,
    GetServiceTypeAction,
    GetServiceTypesAction,
    PersistServiceTypeAction,
    GetOrderServiceTypesAction,
} from '../actions/service-type-actions';
import sortingService from '../../services/sorting';
import { handleError, resolveApiCall, ResolverApiFailure } from '../../services/api-handlers/api-resolver';
import { SubmissionError } from 'redux-form';

function* handleFetchServiceTypes(action: GetServiceTypesAction) {
    const oldData = yield select((state: StoreState) => state.serviceTypes.data);
    const { filters, sorting, page, itemsPerPage } = action.payload;

    yield PaginationService.setPageSize(itemsPerPage).resolveApiCall(action, page, oldData, () =>
        ServiceTypeApi.getServiceTypes({
            ...filters,
            order: sortingService.makeOrder(sorting),
            page,
            itemsPerPage,
            pagination: itemsPerPage === -1 ? 0 : 1,
        }),
    );
}

function* handleFetchServiceType(action: GetServiceTypeAction) {
    const {
        payload: { id },
    } = action;

    yield resolveApiCall(action, () => ServiceTypeApi.getServiceType(id));
}

function* handleDeleteServiceType(action: DeleteServiceTypeAction) {
    const {
        payload: { id, onSuccess, onError },
    } = action;

    yield resolveApiCall(
        action,
        async () => ServiceTypeApi.deleteServiceType(id),
        function () {
            if (onSuccess) {
                onSuccess();
            }
        },
        function (result: ResolverApiFailure) {
            if (result.error && result.error.response && result.error.response.status) {
                if (onError) {
                    onError(result.error.response.data.detail ?? result.error.message ?? 'Unknown error');
                }
            }
            handleError(result);
        },
    );
}

function* handlePersistServiceType(action: PersistServiceTypeAction) {
    const { payload } = action;
    const {
        data: { id, ...restData },

        callbacks,
    } = payload;

    yield resolveApiCall(
        action,
        () => (id ? ServiceTypeApi.updateServiceType(id, restData) : ServiceTypeApi.createServiceType(restData)),
        function* () {
            yield call(callbacks.resolve);
        },
        function* (result: ResolverApiFailure) {
            if (result.error && result.error.response && result.error.response.status) {
                return yield call(
                    callbacks.reject,
                    result.error instanceof SubmissionError
                        ? result.error
                        : new SubmissionError({
                              _error: result.error.message ?? 'Incorrect response',
                          }),
                );
            }
            yield handleError(result);
        },
    );
}
function* handleFetchServiceTypesOrder(action: GetOrderServiceTypesAction) {
    // const { filters, sorting, page, limit } = action.payload;
    const { type } = action.payload;

    yield resolveApiCall(action, () =>
        ServiceTypeApi.getServiceTypesOrder({
            type: type,
        }),
    );
}

export default function* () {
    yield takeLatest(ServiceTypeActions.STAFF_FETCH_SERVICE_TYPES, handleFetchServiceTypes);
    yield takeLatest(ServiceTypeActions.STAFF_FETCH_ORDER_SERVICE_TYPES, handleFetchServiceTypesOrder);
    yield takeLatest(ServiceTypeActions.STAFF_FETCH_SERVICE_TYPE, handleFetchServiceType);
    yield takeLatest(ServiceTypeActions.STAFF_DELETE_SERVICE_TYPE, handleDeleteServiceType);
    yield takeLatest(ServiceTypeActions.STAFF_PERSIST_SERVICE_TYPE, handlePersistServiceType);
}
